import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';
import { getToken } from '../utils/auth';

/**
 * 创建会员订阅的 Stripe Checkout Session
 */
export const createSubscriptionCheckout = async (planId: string, billingCycle: 'monthly' | 'annual') => {
  const apiBaseUrl = getApiBaseUrl();
  const token = getToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await axios.post(
    `${apiBaseUrl}/api/subscriptions/checkout`,
    {
      planId,
      billingCycle,
    },
    { headers }
  );

  return response.data;
};

/**
 * 创建 Dcoin 充值的 Stripe Checkout Session
 */
export const createTokenCheckout = async (packageId: string, amount: number, dcoin: number) => {
  const apiBaseUrl = getApiBaseUrl();
  const token = getToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await axios.post(
    `${apiBaseUrl}/api/tokens/checkout`,
    {
      packageId,
      amount,
      dcoin,
    },
    { headers }
  );

  return response.data;
};

export const createPaymentIntent = async (amount: number) => {
  const apiBaseUrl = getApiBaseUrl();
  const response = await axios.post(
    `${apiBaseUrl}/payments/intents`,
    { amount },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};




